/* eslint-disable prefer-arrow-callback */
/* eslint-disable jsx-a11y/heading-has-content */
import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { addUtils } from './class-name-helpers';

function getProps({ className, ...props }, baseClass) {
  const { restProps, utilClassNames } = addUtils(props);

  return {
    className: clsx(className, baseClass, utilClassNames),
    ...restProps,
  };
}

const headingDefaultProps = {
  className: '',
};

const headingProps = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  el: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div', 'span']),
};

export const HeadingHero = ({ el: El, ...props }) => <El {...getProps(props, 'ss_heading--hero')} />;

HeadingHero.propTypes = headingProps;
HeadingHero.defaultProps = { el: 'h1', ...headingDefaultProps };

export const HeadingArticle = ({ el: El, ...props }) => <El {...getProps(props, 'ss_heading--article')} />;

HeadingArticle.propTypes = headingProps;
HeadingArticle.defaultProps = { el: 'h2', ...headingDefaultProps };

export const HeadingSection = ({ el: El, ...props }) => <El {...getProps(props, 'ss_heading--section')} />;

HeadingSection.propTypes = headingProps;
HeadingSection.defaultProps = { el: 'h3', ...headingDefaultProps };

export const HeadingPara = ({ el: El, ...props }) => <El {...getProps(props, 'ss_heading--para')} />;

HeadingPara.propTypes = headingProps;
HeadingPara.defaultProps = { el: 'h4', ...headingDefaultProps };

export const HeadingSub = ({ el: El, ...props }) => <El {...getProps(props, 'ss_heading--sub')} />;

HeadingSub.propTypes = headingProps;
HeadingSub.defaultProps = { el: 'h5', ...headingDefaultProps };

export const HeadingLabel = ({ el: El, ...props }) => <El {...getProps(props, 'ss_heading--label')} />;

HeadingLabel.propTypes = headingProps;
HeadingLabel.defaultProps = { el: 'h6', ...headingDefaultProps };

export const HeadingDossier = ({ el: El, ...props }) => <El {...getProps(props, 'ss_heading--dossier')} />;

HeadingDossier.propTypes = headingProps;
HeadingDossier.defaultProps = { el: 'h6', ...headingDefaultProps };
